import { View, ViewProps } from 'react-native';
import { cn } from '@/lib/utils';

export interface ScreenBottomBarProps extends ViewProps {}

/**
 * A fixed bottom bar pinned to the bottom of a screen while content scrolls.
 *
 * Render it as the LAST sibling of a `flex-1` ScrollView inside a `flex-1`
 * column container — pinning is achieved with flex layout, not absolute
 * positioning, so it never scrolls with the content.
 */
export const ScreenBottomBar = ({
  className,
  ...props
}: ScreenBottomBarProps) => {
  return (
    <View
      {...props}
      className={cn(
        'bg-background border-t border-border px-5 pt-2 pb-4',
        className,
      )}
    />
  );
};
